module.exports = __webpack_public_path__ + "media/images/flags/16/Mayotte-fdcddf6dc20688959c12bee6717bc19e.png";